window.SpookyProductSection = (function () {

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2).replace('.', ',');
    return amount + ' ₺';
  }

  function initGallery(root) {
    var mainImg = root.querySelector('img[id^="sp-main-img-"]');
    var thumbs = root.querySelectorAll('.sp-thumb');
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function (e) {
        e.preventDefault();
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
        var fullSrc = thumb.getAttribute('data-full');
        if (mainImg && fullSrc) {
          mainImg.removeAttribute('srcset');
          mainImg.src = fullSrc;
        }
      });
    });
  }

  function initQuantity(root, sectionId) {
    var input = root.querySelector('#sp-qty-input-' + sectionId);
    var minusBtn = root.querySelector('[data-action="decrease"]');
    var plusBtn = root.querySelector('[data-action="increase"]');
    if (!input) return null;

    minusBtn && minusBtn.addEventListener('click', function () {
      var val = parseInt(input.value, 10) || 1;
      input.value = Math.max(1, val - 1);
    });
    plusBtn && plusBtn.addEventListener('click', function () {
      var val = parseInt(input.value, 10) || 1;
      input.value = val + 1;
    });

    return input;
  }

  function initCountdown(root, sectionId, fallbackHours) {
    var timerEl = root.querySelector('#sp-timer-' + sectionId);
    if (!timerEl) return;

    var hours = parseInt(timerEl.getAttribute('data-hours'), 10) || fallbackHours || 24;
    var storageKey = 'sp-countdown-' + sectionId;
    var endTime = parseInt(localStorage.getItem(storageKey), 10);
    var now = Date.now();

    if (!endTime || endTime < now) {
      endTime = now + hours * 60 * 60 * 1000;
      localStorage.setItem(storageKey, endTime);
    }

    var hEl = timerEl.querySelector('[data-unit="h"]');
    var mEl = timerEl.querySelector('[data-unit="m"]');
    var sEl = timerEl.querySelector('[data-unit="s"]');

    function pad(n) { return String(n).padStart(2, '0'); }

    function tick() {
      var diff = endTime - Date.now();
      if (diff <= 0) {
        endTime = Date.now() + hours * 60 * 60 * 1000;
        localStorage.setItem(storageKey, endTime);
        diff = endTime - Date.now();
      }
      var totalSeconds = Math.floor(diff / 1000);
      var h = Math.floor(totalSeconds / 3600);
      var m = Math.floor((totalSeconds % 3600) / 60);
      var s = totalSeconds % 60;
      if (hEl) hEl.textContent = pad(h);
      if (mEl) mEl.textContent = pad(m);
      if (sEl) sEl.textContent = pad(s);
    }

    tick();
    setInterval(tick, 1000);
  }

  // Shared price/variant UI updater used by both the color-variant picker and the pack buttons.
  function createPriceController(root, sectionId) {
    var hiddenInput = root.querySelector('#sp-variant-id-' + sectionId);
    var addBtn = root.querySelector('#sp-add-btn-' + sectionId);
    var addBtnText = addBtn ? addBtn.querySelector('.sp-add-btn__text') : null;
    var priceSaleEl = root.querySelector('#sp-price-sale-' + sectionId);
    var priceCompareEl = root.querySelector('#sp-price-compare-' + sectionId);
    var mainImg = root.querySelector('img[id^="sp-main-img-"]');

    function apply(data) {
      if (!data) return;

      if (hiddenInput && data.id) hiddenInput.value = data.id;

      if (priceSaleEl && typeof data.price === 'number') {
        priceSaleEl.textContent = formatMoney(data.price);
      }
      if (priceCompareEl) {
        if (data.compare_at_price && data.compare_at_price > data.price) {
          priceCompareEl.textContent = formatMoney(data.compare_at_price);
          priceCompareEl.style.display = '';
        } else {
          priceCompareEl.style.display = 'none';
        }
      }

      if (addBtn) {
        if (data.available !== false) {
          addBtn.disabled = false;
          if (addBtnText) addBtnText.textContent = addBtn.getAttribute('data-add-text') || addBtnText.textContent;
        } else {
          addBtn.disabled = true;
          if (addBtnText) addBtnText.textContent = addBtn.getAttribute('data-soldout-text') || 'Stokta Yok';
        }
      }

      if (mainImg && data.image) {
        mainImg.removeAttribute('srcset');
        mainImg.src = data.image;
      }
    }

    return { apply: apply };
  }

  function initVariants(root, sectionId, priceController) {
    var wrapper = root.querySelector('#sp-variants-' + sectionId);
    var jsonEl = root.querySelector('#sp-variants-json-' + sectionId);
    if (!wrapper || !jsonEl) return null;

    var variants;
    try {
      variants = JSON.parse(jsonEl.textContent);
    } catch (e) {
      return null;
    }

    var groups = wrapper.querySelectorAll('.sp-variant-group');

    function getSelectedValues() {
      var values = [];
      groups.forEach(function (group) {
        var active = group.querySelector('.sp-variant-pill.is-active');
        var index = parseInt(group.getAttribute('data-option-index'), 10);
        values[index] = active ? active.getAttribute('data-value') : null;
      });
      return values;
    }

    function findMatchingVariant(selectedValues) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var opts = [v.option1, v.option2, v.option3];
        var match = true;
        for (var j = 0; j < selectedValues.length; j++) {
          if (selectedValues[j] !== null && opts[j] !== selectedValues[j]) {
            match = false;
            break;
          }
        }
        if (match) return v;
      }
      return null;
    }

    function currentVariant() {
      return findMatchingVariant(getSelectedValues());
    }

    function toPriceData(variant) {
      if (!variant) return null;
      return {
        id: variant.id,
        price: variant.price,
        compare_at_price: variant.compare_at_price,
        available: variant.available,
        image: variant.featured_image && variant.featured_image.src ? variant.featured_image.src : null
      };
    }

    wrapper.addEventListener('click', function (e) {
      var pill = e.target.closest('.sp-variant-pill');
      if (!pill) return;

      var group = pill.closest('.sp-variant-group');
      group.querySelectorAll('.sp-variant-pill').forEach(function (p) {
        p.classList.remove('is-active');
      });
      pill.classList.add('is-active');

      var label = group.querySelector('.sp-variant-group__selected');
      if (label) label.textContent = pill.getAttribute('data-value');

      priceController.apply(toPriceData(currentVariant()));
    });

    return {
      getCurrentPriceData: function () { return toPriceData(currentVariant()); },
      show: function () { wrapper.style.display = ''; },
      hide: function () { wrapper.style.display = 'none'; }
    };
  }

  function initMultiPick(root, sectionId, variantsJson) {
    var container = root.querySelector('#sp-multipick-' + sectionId);
    if (!container) return null;

    var optionName = container.getAttribute('data-option-name') || 'Seçenek';

    // Build the list of distinct option1 values (assumes the first product option
    // is the one that matters for "mixed pack" selection, e.g. color).
    var seen = {};
    var choices = [];
    variantsJson.forEach(function (v) {
      if (v.option1 && !seen[v.option1]) {
        seen[v.option1] = true;
        choices.push({ value: v.option1, available: v.available });
      }
    });

    function findVariantByOption1(value) {
      for (var i = 0; i < variantsJson.length; i++) {
        if (variantsJson[i].option1 === value) return variantsJson[i];
      }
      return null;
    }

    function render(count) {
      container.innerHTML = '';
      if (!choices.length) return;

      var title = document.createElement('p');
      title.className = 'sp-multipick__title';
      title.textContent = 'Her ürün için ' + optionName.toLowerCase() + ' seçin';
      container.appendChild(title);

      for (var i = 0; i < count; i++) {
        var row = document.createElement('div');
        row.className = 'sp-multipick__row';

        var label = document.createElement('span');
        label.className = 'sp-multipick__label';
        label.textContent = (i + 1) + '. Ürün';

        var select = document.createElement('select');
        select.className = 'sp-multipick__select';
        select.setAttribute('data-unit-index', i);

        choices.forEach(function (choice, choiceIndex) {
          var opt = document.createElement('option');
          opt.value = choice.value;
          opt.textContent = choice.available ? choice.value : (choice.value + ' (Stokta Yok)');
          if (!choice.available) opt.disabled = true;
          // Default: cycle through available choices so a 2-pack starts as two different colors when possible.
          if (choiceIndex === i % choices.length && choice.available) {
            opt.selected = true;
          }
          select.appendChild(opt);
        });

        row.appendChild(label);
        row.appendChild(select);
        container.appendChild(row);
      }
    }

    return {
      show: function (count) {
        render(count);
        container.style.display = '';
      },
      hide: function () {
        container.style.display = 'none';
        container.innerHTML = '';
      },
      isActive: function () {
        return container.style.display !== 'none' && container.children.length > 0;
      },
      getSelectedVariants: function () {
        var selects = container.querySelectorAll('.sp-multipick__select');
        var result = [];
        selects.forEach(function (select) {
          var variant = findVariantByOption1(select.value);
          if (variant) result.push(variant);
        });
        return result;
      }
    };
  }

  function initPacks(root, sectionId, qtyInput, priceController, variantController, multiPickController) {
    var wrapper = root.querySelector('#sp-packs-' + sectionId);
    if (!wrapper) return;
    var packs = wrapper.querySelectorAll('.sp-pack');
    if (!packs.length) return;

    packs.forEach(function (pack) {
      pack.addEventListener('click', function () {
        packs.forEach(function (p) { p.classList.remove('is-active'); });
        pack.classList.add('is-active');

        var qty = parseInt(pack.getAttribute('data-qty'), 10) || 1;
        if (qtyInput) qtyInput.value = qty;

        var linkedVariantId = pack.getAttribute('data-linked-variant');

        if (linkedVariantId) {
          // This pack is tied to a real separate Shopify product/variant with its own price.
          if (multiPickController) multiPickController.hide();
          if (variantController) variantController.hide();
          priceController.apply({
            id: linkedVariantId,
            price: parseInt(pack.getAttribute('data-linked-price'), 10),
            compare_at_price: parseInt(pack.getAttribute('data-linked-compare'), 10) || 0,
            available: pack.getAttribute('data-linked-available') === 'true'
          });
        } else if (qty > 1 && multiPickController) {
          // Multi-unit pack with no fixed bundle product: let the customer pick a
          // different color for each unit, e.g. 1 pink + 1 gray in a 2-pack.
          if (variantController) variantController.hide();
          multiPickController.show(qty);
        } else {
          // Single unit: fall back to whichever color/variant is currently selected.
          if (multiPickController) multiPickController.hide();
          if (variantController) {
            variantController.show();
            priceController.apply(variantController.getCurrentPriceData());
          }
        }
      });
    });
  }

  function initMultiAddToCart(root, sectionId, multiPickController) {
    var form = root.querySelector('.sp-form');
    if (!form || !multiPickController) return;

    var addBtn = root.querySelector('#sp-add-btn-' + sectionId);
    var addBtnText = addBtn ? addBtn.querySelector('.sp-add-btn__text') : null;
    var originalText = addBtnText ? addBtnText.textContent : null;

    form.addEventListener('submit', function (e) {
      if (!multiPickController.isActive()) return; // let the normal single-item form submit as usual

      e.preventDefault();

      var variants = multiPickController.getSelectedVariants();
      if (!variants.length) return;

      if (addBtn) addBtn.disabled = true;
      if (addBtnText) addBtnText.textContent = 'Ekleniyor...';

      var addPromises = variants.map(function (variant) {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variant.id, quantity: 1 })
        }).then(function (res) {
          if (!res.ok) throw new Error('add-failed');
          return res.json();
        });
      });

      Promise.all(addPromises)
        .then(function () {
          window.location.href = '/cart';
        })
        .catch(function () {
          if (addBtn) addBtn.disabled = false;
          if (addBtnText) addBtnText.textContent = originalText || 'Sepete Ekle';
          alert('Ürünler sepete eklenirken bir sorun oluştu, lütfen tekrar deneyin.');
        });
    });
  }

  function init(rootId, options) {
    var root = document.getElementById(rootId);
    if (!root) return;
    options = options || {};
    var sectionId = options.sectionId;

    initGallery(root);
    var qtyInput = initQuantity(root, sectionId);
    initCountdown(root, sectionId, options.countdownHours);

    var priceController = createPriceController(root, sectionId);
    var variantController = initVariants(root, sectionId, priceController);

    var jsonEl = root.querySelector('#sp-variants-json-' + sectionId);
    var multiPickController = null;
    if (jsonEl) {
      try {
        var variantsJson = JSON.parse(jsonEl.textContent);
        multiPickController = initMultiPick(root, sectionId, variantsJson);
      } catch (e) {
        multiPickController = null;
      }
    }

    initPacks(root, sectionId, qtyInput, priceController, variantController, multiPickController);
    initMultiAddToCart(root, sectionId, multiPickController);
  }

  return { init: init };
})();
